export enum ProjectStatus {
    ACTIVE = "A",
    DORMANT = "D",
    INACTIVE = "I",
}
